import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';

import { I18N_NAMESPACE } from '../translation/translate.token';

export const VALIDATION_MESSAGES = new InjectionToken<ValidationMessages>('shrd-utc.validationMessages');

export interface ValidatorProps {
  [key: string]: string | number;
}

interface ValidationResult {
  [validator: string]: string | boolean | ValidatorProps;
}

export interface ValidationMessages {
  get(key: string, context: string, props: ValidatorProps, ns: string | string[]): string;
}

export class DefaultMessages implements ValidationMessages {
  generic = 'Validation failed: {{key}}';
  required = 'Please enter a value';
  requiredTrue = 'Please set required selection';
  minChecked = 'Please select at least {{requiredMinChecked}} option(s)';
  pattern = 'Value does not match required pattern';
  minlength = 'Value must be a minimum of {{requiredLength}} characters';
  maxlength = 'Value must be a maximum of {{requiredLength}} characters';
  password = 'Value does not meet all criteria.';

  get(key: string, context: string = null, props: ValidatorProps = {}): string {
    const message = this[key];
    return (
      message && Object.keys(props).reduce((msg, prop) => msg.replace(`{{${prop}}}`, props[prop].toString()), message)
    );
  }
}

@Injectable()
export class ValidateMessageService {
  constructor(
    @Optional() @Inject(VALIDATION_MESSAGES) private readonly validationMessages,
    @Optional() @Inject(I18N_NAMESPACE) private readonly i18nNamespace
  ) {
    if (!this.validationMessages) {
      this.validationMessages = new DefaultMessages();
    }
  }

  getMessage(validator: ValidationResult, key: string, context: string = null): string {
    const message = this.validationMessages.get(key, context, validator[key], this.i18nNamespace);

    if (message) {
      return message;
    }

    if (typeof validator[key] === 'string') {
      return validator[key] as string;
    } else {
      return this.validationMessages.get('generic', context, { key }, this.i18nNamespace);
    }
  }
}
